import { Modal, ModalBody, ModalContent, ModalOverlay, Text } from "@chakra-ui/react";
import { colors } from "../../styles";

interface TextModalProps {
    isOpen: boolean;
    onClose: () => void;
    text: string;
}

export default function TextModal(props: TextModalProps) {
    return (
        <Modal motionPreset="slideInBottom" size={"xl"} isOpen={props.isOpen} onClose={props.onClose}>
            <ModalOverlay />
            <ModalContent>
                <ModalBody padding={5}>
                    <Text fontSize={16} fontWeight={400} color={colors.black} whiteSpace={"pre-wrap"}>
                        {props.text}
                    </Text>
                </ModalBody>
            </ModalContent>
        </Modal>
    )
}